<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (close)="confirmAddress()"
  [modal]="true"
  [styleClass]="'dialog-container'"
  position="top"
  [closable]="true"
  [closeOnEscape]="true"
  [style]="{
    'max-width': '1024px',
    'min-height': '600px',
    'margin-left': '10px',
    'margin-right': '10px',
    'background-color': '#fff'
  }"
>
  <p-header>{{ locationName }} Address</p-header>

  <form [formGroup]="addressForm">
    <div class="dialog-body">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6 address-entry px-0">
          <div class="ui-g">
            <div class="ui-g-12">
              <span class="ui-float-label">
                <input
                  pInputText
                  id="businessName"
                  class="b2c-input"
                  formControlName="businessName"
                />
                <label for="businessName">Business Name</label>
              </span>
            </div>
          </div>

          <div class="ui-g">
            <div class="ui-g-12">
              <span class="ui-float-label">
                <input
                  pInputText
                  id="addressLine1"
                  class="b2c-input"
                  formControlName="addressLine1"
                />
                <label for="addressLine1">Address Line 1</label>
              </span>
            </div>
          </div>

          <div class="ui-g">
            <div class="ui-g-12">
              <span class="ui-float-label">
                <input
                  pInputText
                  id="addressLine2"
                  class="b2c-input"
                  formControlName="addressLine2"
                />
                <label for="addressLine2">Address Line 2</label>
              </span>
            </div>
          </div>

          <div class="ui-g">
            <div class="ui-g-12">
              <span class="ui-float-label">
                <input
                  pInputText
                  id="addressLine3"
                  class="b2c-input"
                  formControlName="addressLine3"
                />
                <label for="addressLine3">Address Line 3</label>
              </span>
            </div>
          </div>

          <div class="ui-g">
            <div class="ui-md-6">
              <div class="mb-2">
                <span class="ui-float-label">
                  <input pInputText id="city" class="b2c-input" formControlName="city" />
                  <label for="city">City</label>
                </span>
              </div>
            </div>

            <div class="ui-md-6">
              <div class="mb-2">
                <span class="ui-float-label">
                  <input pInputText id="postcode" class="b2c-input" formControlName="postcode" />
                  <label for="postcode">Postcode</label>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="ui-g-12 ui-md-6">
          <div style="height: 315px">
            <app-google-map-dragdrop
              [lat]="af.latitude"
              [lng]="af.longitude"
              [restrictBounds]="0.01"
              (addressChange)="addressChange($event)"
            ></app-google-map-dragdrop>
            <div class="mb-2">
              <span style="font-size: 12px">
                Lat: {{ af?.lat | number : '1.3-3' }} Lng: {{ af?.lng | number : '1.3-3' }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-6">
          <div><span style="font-size: 20px; font-weight: 500">Increased accuracy</span></div>
          <div>
            <span style="letter-spacing: -0.4px"
              >Sometimes a postcode doesn't point to the correct location, or simply a postcode does
              not exist yet (common with new buildings).
            </span>
          </div>
        </div>
        <div class="ui-g-6">
          You can <strong>drag and drop</strong> the red map pin to the required location, our
          drivers will visit those exact geo co-ordinates.
        </div>
      </div>
      <div style="border-top: 1px solid #ced4da; padding-top: 20px; padding-bottom: 20px">
        <div class="text-right">
          <span class="big-button selected" (click)="confirmAddress()">Confirm Address</span>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
